import { useState, useEffect } from 'react';

function DemandaItemFormModal({ show, onClose, onSave, descricao = '', observacao = '', isEdit = false }) {
  const [formData, setFormData] = useState({ descricao: '', observacao: '' });

  useEffect(() => {
    if (show) {
      setFormData({ descricao, observacao });
    }
  }, [show, descricao, observacao]);

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = e => {
    e.preventDefault();
    onSave(formData);
  };

  if (!show) return null;

  return (
    <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content" style={{ borderRadius: '0.5rem', overflow: 'hidden' }}>
          <div
            className="modal-header text-white py-2"
            style={{
              background: 'linear-gradient(45deg, rgb(30, 27, 75) 0%, rgb(55, 48, 163) 100%)',
              border: 'none',
            }}
          >
            <h6 className="modal-title">
              <i className={`bi ${isEdit ? 'bi-pencil' : 'bi-plus-circle'} me-2`}></i>
              {isEdit ? 'Editar Tópico' : 'Novo Tópico'}
            </h6>
            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal-body py-3">
              <div className="mb-3">
                <label className="form-label fw-semibold">Descrição *</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  name="descricao"
                  value={formData.descricao}
                  onChange={handleChange}
                  required
                  placeholder="Descreva a tarefa..."
                  autoFocus
                />
              </div>
              <div className="mb-0">
                <label className="form-label fw-semibold">Observação</label>
                <textarea
                  className="form-control form-control-sm"
                  name="observacao"
                  value={formData.observacao}
                  onChange={handleChange}
                  rows={3}
                  placeholder="Observações adicionais..."
                />
              </div>
            </div>
            <div className="modal-footer py-2">
              <button type="button" className="btn btn-secondary btn-sm" onClick={onClose}>
                Cancelar
              </button>
              <button type="submit" className="btn btn-success btn-sm">
                <i className="bi bi-check me-1"></i>Salvar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default DemandaItemFormModal;
